require('../css/scss/main.scss')

/*
var Packery = require('packery');
require('jquery')
require('moment')
require('pikaday')
*/

require('gsap/src/uncompressed/TweenMax')
require('gsap/src/uncompressed/plugins/CSSPlugin')
require('gsap/src/uncompressed/utils/Draggable')

require('./vendor/greensock/plugins/ThrowPropsPlugin.min.js')
require('./vendor/pikaday.jquery.js')
require('./vendor/cookie-law.js')

require('./modules/menu.js')
require('./modules/show-more.js')
require('./modules/instagram.js')
require('./modules/newsletter.js')
require('./modules/reservations.js')
require('./modules/anchor_effect.js')
require('./modules/scroll_effect.js')
require('./modules/nav-menu.js')
require('./modules/analytics.js')



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/entry.js
 ** module id = 0
 ** module chunks = 0
 **/